export default __webpack_public_path__ + "static/Perform25-Planful-Logo-9dbd108d3cfd70c87831827c8f1a5642.svg";